<template>
  <Card>
    <h1 slot="Title">Army Financial Management & Comptroller (Cont.)</h1>
    <div slot="MainContent">
      <p><b>Army Management Structure (Federated Enterprise Resource Planning Business Systems) Guide</b></p>
      <p>
        This guide provides users essential information about the Master Data Elements used by the Army’s Federated Enterprise Resource Planning (ERP) Business Systems. With this edition, we have begun to expand the scope of the guide to cover master data for all Federated ERP Business Systems, and changed its name from “Army Funds Management Data Reference Guide” to its new name to reflect its applicability to all Army Federated ERP Business Systems.
      </p>
      <p><b>Army Federated Enterprise Resource Planning Business Systems: </b></p>
      <ul>
        <li>
          General Fund Enterprise Business System (GFEBS)

        </li>
        <li>
          Global Combat Support System-Army (GCSS-Army)

        </li>
        <li>
          Logistics Modernization Program (LMP)

        </li>
        <li>
          This guide is a companion to DFAS-IN Manual 37-100, The Army Management Structure.

        </li>
      </ul>
    </div>
    <div slot="Notes">
      <p style="line-height:normal;margin-top:4.32pt;margin-bottom:0pt;margin-left:0in;margin-right:0in;text-indent:0in;text-align:left;vertical-align:baseline;"><span style="font-size: 16px; font-family: Calibri; color: rgb(255, 255, 255); font-weight: bold;">Army Financial Management &amp; Comptroller (Cont.)</span></p>
      <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size: 16px; font-family: Arial; font-weight: bold;">Army Management Structure (Federated ERPs) Guide &nbsp;&nbsp;</span><span style="font-size: 16px; font-family: Calibri;">-&nbsp;</span><span style="font-size: 16px; font-family: Arial;">This guide provides users essential information about the Master Data Elements used by the Army&rsquo;s Federated Enterprise Resource Planning (ERP) Business Systems. With this edition, we have begun to expand the scope of the guide to cover master data for all Federated ERP Business&nbsp;Systems, and&nbsp;changed its name from &ldquo;Army Funds Management Data Reference Guide&rdquo; to its new name to reflect its applicability to all Army Federated ERP Business Systems.</span></span></p>
      <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size: 16px; font-family: Arial; font-weight: bold;">Army Federated Enterprise Resource Planning Business Systems:&nbsp;</span></span></p>
      <div style="margin-top:0pt;margin-bottom:0pt;margin-left:.19in;text-indent:-.19in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size:16px;"><span style="font-family:Arial;">&bull;</span></span><span style="font-size: 16px; font-family: Arial; font-weight: normal;">General Fund Enterprise Business System (GFEBS)</span></span></div>
      <div style="margin-top:0pt;margin-bottom:0pt;margin-left:.19in;text-indent:-.19in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size:16px;"><span style="font-family:Arial;">&bull;</span></span><span style="font-size: 16px; font-family: Arial; font-weight: normal;">Global Combat Support System-Army (GCSS-Army)</span></span></div>
      <div style="margin-top:0pt;margin-bottom:0pt;margin-left:.19in;text-indent:-.19in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size:16px;"><span style="font-family:Arial;">&bull;</span></span><span style="font-size: 16px; font-family: Arial; font-weight: normal;">Logistics Modernization Program (LMP)</span></span></div>
      <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size: 16px; font-family: Arial; color: rgb(255, 255, 255);">This guide is a companion to DFAS-IN Manual 37-100, The Army Management Structure.</span></p>
    </div>
  </Card>
</template>

<script>
import Card from '../../../components/Card.vue';

export default {

  components: {
    Card
  },
  name: 'ArmyFinancialManagementAndComptrollerCont2',
  
  data() {
    return {
    }
  }
  
}
</script>